import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index/index'
import login from '@/views/login/login'
import article from '@/views/article/article'
import type from '@/views/index/type'
import score from '@/views/index/score'
import particulars from '@/views/index/particulars'
import cart from '@/views/cart/cart'
import newOrder from '@/views/cart/newOrder'
import pay from '@/views/cart/pay'
import success from '@/views/cart/success'
import person from '@/views/person/person'
import order from '@/views/person/order'
import info from '@/views/person/info'
import address from '@/views/person/address'
import about from '@/views/person/about'
import changePass from '@/views/person/changePass'
import record from '@/views/person/record'
import detail from '@/views/person/detail'
import refund from '@/views/person/refund'
import evaluate from '@/views/person/evaluate'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			component: index,
			name: 'index',
		},
		{
			path: '/login',
			component: login,
			name: 'login',
		},
		{
			path: '/article',
			component: article,
			name: 'article',
		},
		{
			path: '/type',
			component: type,
			name: 'type',
		},
		{
			path: '/score',
			component: score,
			name: 'score',
		},
		{
			path: '/particulars',
			component: particulars,
			name: 'particulars',
		},
		{
			path: '/cart',
			component: cart,
			name: 'cart',
		},
		{
			path: '/newOrder',
			component: newOrder,
			name: 'newOrder',
		},
		{
			path: '/pay',
			component: pay,
			name: 'pay',
		},
		{
			path: '/success',
			component: success,
			name: 'success',
		},
		{
			path: '/person',
			component: person,
			name: 'person',
			redirect: '/person/order',
			children:[
				{
					path: '/person/order',
					component: order,
					name: 'order',
				},
				{
					path: '/person/info',
					component: info,
					name: 'info',
				},
				{
					path: '/person/address',
					component: address,
					name: 'address',
				},
				{
					path: '/person/about',
					component: about,
					name: 'about',
				},
				{
					path: '/person/changePass',
					component: changePass,
					name: 'changePPass',
				},
				{
					path: '/person/record',
					component: record,
					name: 'record',
				}
			]
		},
		{
			path: '/detail',
			component: detail,
			name: 'detail',
		},
		{
			path: '/refund',
			component: refund,
			name: 'refund',
		},
		{
			path: '/evaluate',
			component: evaluate,
			name: 'evaluate',
		}
	]
})
